import {
  getTransactionTypeLabel,
  type TransactionLabelProps,
} from './labelByTransactionType'

export function TransactionTypeLabel({ typeId, flag }: TransactionLabelProps) {
  return (
    <div className="w-fit px-[3px] py-0.25 border  rounded text-xs items-center justify-center uppercase">
      {getTransactionTypeLabel({ typeId, flag })}
    </div>
  )
}
